export var PI = Math.PI;
export var TAU = PI * 2;
export var HALF_PI = PI / 2;
export var THIRD_PI = PI / 3;
export var QUARTER_PI = PI / 4;
export var SIXTH_PI = PI / 6;
export var INV_PI = 1 / PI;
export var INV_TAU = 1 / TAU;
export var INV_HALF_PI = 1 / HALF_PI;
export var DEG2RAD = PI / 180;
export var RAD2DEG = 180 / PI;
export var PHI = (1 + Math.sqrt(5)) / 2;
export var SQRT2 = Math.SQRT2;
export var SQRT3 = Math.sqrt(3);
export var SQRT2_2 = SQRT2 / 2;
export var SQRT2_3 = SQRT3 / 2;
export var THIRD = 1 / 3;
export var TWO_THIRD = 2 / 3;
export var SIXTH = 1 / 6;
export var EPS = 1e-6;
export var Crossing;

(function (Crossing) {
  /**
   * lines A & B are equal
   */
  Crossing[Crossing["EQUAL"] = 0] = "EQUAL";
  /**
   * lines A & B are flat (all same values)
   */

  Crossing[Crossing["FLAT"] = 1] = "FLAT";
  /**
   * line A crossed under B
   */

  Crossing[Crossing["UNDER"] = 2] = "UNDER";
  /**
   * line A crossed over B
   */

  Crossing[Crossing["OVER"] = 3] = "OVER";
  Crossing[Crossing["OTHER"] = 4] = "OTHER";
})(Crossing || (Crossing = {}));